import { exhaustiveSwitchWithDefault } from "@faire/web--source/common/exhaustiveSwitchWithDefault";
import { useStrictLocalization } from "@faire/web--source/common/localization";
import { useSettingHeaderNavSignupCTACopy } from "@faire/retailer/settings/useSettingHeaderNavSignupCTACopy";
export var useHeaderSignUpCopy = function() {
    var setting = useSettingHeaderNavSignupCTACopy();
    var strictLocalize = useStrictLocalization().strictLocalize;
    switch(setting){
        case "CONTROL":
        case "BUCKET_UNKNOWN":
            return strictLocalize({
                id: "K/hTTE",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Sign up to shop"
                    }
                ]
            });
        case "VARIANT_2":
            return strictLocalize({
                id: "coXYHH",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Join free"
                    }
                ]
            });
        case "VARIANT_3":
            return strictLocalize({
                id: "e13Mfi",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Sign up"
                    }
                ]
            });
        case "VARIANT_4":
            return strictLocalize({
                id: "i0+bW2",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Get started"
                    }
                ]
            });
        case "VARIANT_5":
            return strictLocalize({
                id: "J8oMWG",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Sign up to buy"
                    }
                ]
            });
        default:
            return exhaustiveSwitchWithDefault("")(setting);
    }
};
